module.exports = __webpack_public_path__ + "img/PL09058.511627f8.png";